/**************************************************
 * Nombre:       Tarjeta_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";


const Tarjeta_Testimonio = ({item}) => {

    return (

        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                p: 5
            }}
        >


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: 'white',
                    boxShadow: 3,
                    p: 4,

                }}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -8}}>
                    <Avatar src={item.img} sx={{width: 64, height: 64}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                    <Typography sx={{color: '#838383', textAlign: 'center', fontSize: 16}}>
                        {item.descripcion}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                    <Typography sx={{
                        color: theme.palette.secondary.main,
                        textAlign: "center",
                        fontFamily: NEGRITA,
                        fontSize: 20
                    }}>{item.nombre}</Typography>
                </Grid>

            </Grid>
        </Grid>

    )

}
export default Tarjeta_Testimonio